import giftItemQueries from '@apis/queries/giftItemQueries';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useGiftItem(giftItemId: string) {
    const { data, status } = useQuery(giftItemQueries.detail(giftItemId));
    const { pop } = useFlow();
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('giftItem.loadError'));
            pop();
        }
    }, [pop, status, t]);
    return data;
}

export default useGiftItem;
